module.exports = __webpack_public_path__ + "2cc2eaaea8729584a93342eb616b0c2f.svg";